interface DashboardWelcomeHeaderProps {
  userName?: string;
  formattedDate: string;
}

export default function DashboardWelcomeHeader({
  userName,
  formattedDate,
}: DashboardWelcomeHeaderProps) {
  return (
    <div>
      <h2 className="text-lg sm:text-xl font-medium">Hello, {userName}</h2>
      <p className="text-gray-500 dark:text-gray-400 text-sm">
        <span id="timer"></span> {formattedDate}
      </p>
    </div>
  );
}
